import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { IMyDpOptions } from 'mydatepicker';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BulkRenewalRequestService } from '../service/bulk-renewal-request.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Router } from '@angular/router';

export interface RenewalModalModel {
  title: string;
  message: string;
  warning: string;
}

@Component({
  selector: 'app-renewal-modal',
  templateUrl: './renewal-modal.component.html',
  styleUrls: ['./renewal-modal.component.scss']
})
export class RenewalModalComponent extends DialogComponent<RenewalModalModel, boolean> implements RenewalModalModel, OnInit {
  
  title: string;
  message: string;
  warning: string;

  public bulkRenewalForm: FormGroup;

  public clientesSemTipo : Array<any> = new Array<any>();

  private myDatePickerOptions: IMyDpOptions = {
    dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
    monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
    dateFormat: 'dd/mm/yyyy',
    showTodayBtn: false,
  };
 
  constructor(public dialogService: DialogService, private fb: FormBuilder, private bulkRenewalRequestService: BulkRenewalRequestService, private flashMessagesService: FlashMessagesService, private router: Router) {
    super(dialogService);
    this.bulkRenewalForm = this.fb.group({
      'DataNovaVigencia': [""],
      'DataNovaVigenciaAdicional': [""],
      'ValorNovoLC': [""],
      'ValorNovoLCAdicional': [""]
    });
  }

  ngOnInit(){
    const selectedClients : Array<any> = Array.from(this.bulkRenewalRequestService.getSelectClientsProperties()); 
    this.clientesSemTipo = selectedClients.filter(item => item.TipoCliente == 'Não Definido');
  }



  submit() {
    const dataNovaVigencia = this.bulkRenewalForm.controls.DataNovaVigencia.value;
    const dataNovaVigenciaAdicional = this.bulkRenewalForm.controls.DataNovaVigenciaAdicional.value;
    const valorNovoLC = this.bulkRenewalForm.controls.ValorNovoLC.value;
    const valorNovoLCAdicional = this.bulkRenewalForm.controls.ValorNovoLCAdicional.value;
    const clients = this.bulkRenewalRequestService.getSelectClients();

    this.bulkRenewalRequestService.criarProposta(dataNovaVigencia, dataNovaVigenciaAdicional, valorNovoLC, valorNovoLCAdicional, clients).subscribe(
      result => {
        if (result.Success) {
          this.flashMessagesService.show("Proposta de Renovação de Vigência de LC criada!", { cssClass: 'alert-success', timeout: 6000 });

          this.router.navigateByUrl('/').then(
            () => {
              this.router.navigateByUrl('/renovacao-vigencia/' + result.Result);
            });
        }
        else {
          this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
        }
        this.close();
      },
      error => {
        console.log(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/bulk-renewal/component/bulk-renewal-request/renewal-modal/renewal-modal.component.ts